import { useEffect } from 'react';

export function useRevealOnScroll(rootRef, selector = '.v4-reveal') {
  useEffect(() => {
    const root = rootRef?.current || document;
    const nodes = root.querySelectorAll(selector);
    if (!nodes.length) return undefined;

    const obs = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-in');
            obs.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12 }
    );

    nodes.forEach((el) => obs.observe(el));
    return () => obs.disconnect();
  }, [rootRef, selector]);
}
